import { Papel } from "../../service/restricao/Papeis";
import { RestricaoBuscaFormulario } from "service/restricao/TipoRestricaoFormulario/RestricaoBuscaFormulario";
import { BuscaSemAcesso, BuscaSemRestricao, SemRestricao } from "service/restricao/PermissoesGenericas";
import { RestricoesCamposFormulario } from "service/restricao/RestricoesCamposFormulario";
import { RestricoesFormulario } from "service/restricao/RestricoesFormulario";
import { OperacaoFormularioBusca } from "service/restricao/OperacaoFormulario/OperacaoFormulario";


export interface RestricoesCamposBuscaSolicitacoesFormulario extends RestricoesCamposFormulario {
  titulo: RestricaoBuscaFormulario;
  situacao: RestricaoBuscaFormulario;
  idSolicitante: RestricaoBuscaFormulario;

  prioridade: RestricaoBuscaFormulario;
  idResponsavelTecnico: RestricaoBuscaFormulario;
  idUnidadeResponsavel: RestricaoBuscaFormulario;

  dataCriacao: RestricaoBuscaFormulario;
}


const UsuarioComum: Readonly<RestricoesCamposBuscaSolicitacoesFormulario> = {
  titulo: BuscaSemRestricao,
  situacao: BuscaSemRestricao,
  idSolicitante: BuscaSemAcesso,

  prioridade: BuscaSemRestricao,
  idResponsavelTecnico: BuscaSemAcesso,
  idUnidadeResponsavel: BuscaSemRestricao,

  dataCriacao: BuscaSemRestricao,
}

const Nivel1: Readonly<RestricoesCamposBuscaSolicitacoesFormulario> = {
  ...UsuarioComum,
  idSolicitante: {
    [OperacaoFormularioBusca.Buscar]: {...SemRestricao, clearable: true },
  },
  idResponsavelTecnico: BuscaSemRestricao,
  idUnidadeResponsavel: BuscaSemRestricao,
}


export const RestricoesBuscaSolicitacoesFormulario: RestricoesFormulario<RestricoesCamposBuscaSolicitacoesFormulario> = {
  [Papel.UsuarioComum]: UsuarioComum,
  [Papel.Nivel1]: Nivel1,
  [Papel.Nivel2]: Nivel1,
  [Papel.Administrador]: Nivel1,
}
